// extracted by mini-css-extract-plugin
export var cardSelected = "_ik-2";
export var image = "_ik-1";
export var table = "_ik-0";